'use strict';
import ConstCode from '@/common/constants/ConstCode';

class Util {
  constructor() {
    this.ConstCode = ConstCode;
  }

  isEmpty(value) {
    return (
      value === '' || value === null || value === undefined || (typeof value === 'object' && !Object.keys(value).length)
    );
  }

  /**
   * 아이디 정규식 (앱지)
   * 영문 소문자/숫자 조합 6자리 이상
   * @param value
   * @returns {boolean}
   */
  isIdValid(value) {
    if (this.isEmpty(value)) return false;
    const regExp = /^[a-z0-9+]{6,12}$/;
    return regExp.test(value);
  }

  /**
   * 비밀번호 정규식
   * 영문/숫자/특수문자 조합 8자리 이상
   * @param value
   * @returns {boolean}
   */
  isPasswordValid(value) {
    if (this.isEmpty(value)) return false;
    // let regExp = /(?=.*\d{1,50})(?=.*[~`!@#$%\\^&*()-+=]{1,50})(?=.*[a-zA-Z]{1,50}).{8,50}$/
    const regExp1 = /[0-9]/;
    const regExp2 = /[a-zA-Z]/;
    return !(!regExp1.test(value) || !regExp2.test(value) || value.length < 6 || value.length > 50);

    // const regExp3 = /[~!@$#%<>^&*]/;
    // if (!regExp1.test(value) || !regExp2.test(value) || !regExp3.test(value) || value.length < 6 || value.length > 50) {
    //   return false;
    // }
    // return this.isContinueousVaild(value);
  }

  /**
   * 연속된 비밀번호 사용인지 여부 판단
   * @param value
   * @returns {boolean}
   */
  isContinueousVaild(value) {
    let userPwPassed = true;
    let SamePass0 = 0; // 동일문자 카운트
    let SamePass1 = 0; // 연속성(+) 카운드
    let SamePass2 = 0; // 연속성(-) 카운드
    for (let i = 0; i < value.length; i++) {
      let chrPass0;
      let chrPass1;
      let chrPass2;
      if (i >= 2) {
        chrPass0 = value.charCodeAt(i - 2);
        chrPass1 = value.charCodeAt(i - 1);
        chrPass2 = value.charCodeAt(i);
        // 동일문자 카운트
        if (chrPass0 === chrPass1 && chrPass1 === chrPass2) {
          SamePass0++;
        } else {
          SamePass0 = 0;
        }
        // 연속성(+) 카운드
        if (chrPass0 - chrPass1 === 1 && chrPass1 - chrPass2 === 1) {
          SamePass1++;
        } else {
          SamePass1 = 0;
        }
        // 연속성(-) 카운드
        if (chrPass0 - chrPass1 === -1 && chrPass1 - chrPass2 === -1) {
          SamePass2++;
        } else {
          SamePass2 = 0;
        }
      }

      if (SamePass0 > 0) {
        userPwPassed = false;
      }
      if (SamePass1 > 0 || SamePass2 > 0) {
        alert('영문, 숫자는 3자 이상 연속으로 입력할 수 없습니다.');
        return false;
      }
      if (!userPwPassed) {
        alert('동일 문자를 3자 이상 연속으로 입력할 수 없습니다.');
        return false;
      }
    }
    return true;
  }

  /**
   * 휴대폰 번호 정규식
   *  - 01012341234 형식 체크
   * @class Util
   */
  isPhoneValid(value) {
    if (this.isEmpty(value)) return false;
    const regExp = /^((01[1|6|7|8|9])[1-9]+[0-9]{6,7})|(010[1-9][0-9]{7})$/;
    return regExp.test(value);
  }

  /**
   * 핸드폰 하이픈(-) 포맷방식 출력 (type : 0일경우, 가운데 자리 **** 표시)
   * @param num
   * @param type
   * @returns {*|string}
   */
  getPhoneFormat(num, type = 1) {
    let formatNum = '';
    try {
      if (num.length === 11) {
        if (type === 0) {
          formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3');
        } else {
          formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
        }
      } else if (num.length === 8) {
        formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2');
      } else {
        if (num.indexOf('02') === 0) {
          if (num.length === 10) {
            if (type === 0) {
              formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3');
            } else {
              formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
            }
          } else {
            if (type === 0) {
              formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-****-$3');
            } else {
              formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
            }
          }
        } else {
          if (num.length === 10) {
            if (type === 0) {
              formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3');
            } else {
              formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            }
          } else {
            if (type === 0) {
              formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-***-$3');
            } else {
              formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            }
          }
        }
      }
    } catch (e) {
      formatNum = num;
    }
    return formatNum;
  }

  /**
   * 생년월일 번호 정규식
   *  - YYMMDD 형식 체크
   * @class Util
   */
  isBirthValid(value) {
    if (this.isEmpty(value)) return false;
    const regExp = /^(?:[0-9]{4}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
    return regExp.test(value);
  }

  /**
   * 이메일 정규식
   *  - test123@test.com
   * @class Util
   */
  isEmailValid(value) {
    if (this.isEmpty(value)) return false;
    // let regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
    /*
      세종 Email validation
     */
    const regExp =
      /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return regExp.test(value);
  }

  /**
   * 만나이 계산
   *  - YYYYMMDD 형식 체크
   * @class Util
   */
  getBirthAge(birth) {
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    birth.setFullYear(today.getFullYear());
    if (today < birth) age--;
    return age;
  }

  /**
   * age가 되는 날짜를 구함
   *  - YYYYMMDD 형식 체크
   * @class Util
   */
  getAgeToDate(age, birth) {
    const years = birth.getFullYear() + age;
    birth.setFullYear(years);
    return birth;
  }

  getScrollTop() {
    const el = document.getElementById('wrap');
    return el.scrollTop;
  }

  scrollByWrap(position, el) {
    el.scrollBy(0, position);
  }

  scrollToTop(elId, scrollDuration = 300) {
    const _this = this;
    const el = document.getElementById(elId);
    const scrollStep = -el.scrollTop / (scrollDuration / 15);
    const scrollInterval = setInterval(function () {
      if (el.scrollTop !== 0) {
        _this.scrollByWrap(scrollStep, el);
        // el.scrollBy(0, scrollStep)
      } else {
        clearInterval(scrollInterval);
      }
    }, 12);
  }

  scrollToEl(el, scrollDuration = 300) {
    const _this = this;
    const scrollStep = -el.scrollTop / (scrollDuration / 15);
    const scrollInterval = setInterval(function () {
      if (el.scrollTop !== 0) {
        _this.scrollByWrap(scrollStep, el);
        // el.scrollBy(0, scrollStep)
      } else {
        clearInterval(scrollInterval);
      }
    }, 12);
  }

  scrollLock(isLock = false) {
    document.body.className = '';
    if (isLock) document.body.className = 'scroll_lock';
  }

  isMobile() {
    const body = document.getElementsByTagName('body');
    return body[0].clientWidth < 1000;
    // return (screen.width < 1000)
  }

  isScrollBar() {
    return (
      (document.getElementById('test').scrollHeight === 0 && document.getElementById('test').clientHeight === 0) ||
      document.getElementById('test').scrollHeight > document.getElementById('test').clientHeight
    );
  }

  formatNumber(value) {
    if (this.isEmpty(value)) return 0;
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  formatNumber2(value, options) {
    if (this.isEmpty(value) || isNaN(value) || value === 0) return '-';
    const dl = options.decimalLength || 0;
    const ts = options.thousandsSep || ',';
    const ty = options.type || '';
    const ut = options.unit || '';

    if (ty !== '') value = value * 100;
    value = parseFloat(value);
    const re = '\\d(?=(\\d{3})+' + (dl > 0 ? '\\D' : '$') + ')';
    const num = value.toFixed(Math.max(0, ~~dl));
    return `${num.replace(new RegExp(re, 'g'), '$&' + ts)}${ut}`;
  }

  calcUnit(value, area) {
    return value / area;
  }

  calcUnitCut(value, unit) {
    if (isNaN(value)) value = 0;
    return Math.floor(value / unit) * unit;
  }

  formatDate(value, options = { flag: false }) {
    let text = '';
    const flag = options.flag || false;
    if (value.length === 6) {
      text = flag
        ? `${value.substring(0, 4)}년 ${value.substring(4, 6)}월`
        : `${value.substring(0, 4)}-${value.substring(4, 6)}`;
    } else if (value.length === 8) {
      text = flag
        ? `${value.substring(0, 4)}년 ${value.substring(4, 6)}월 ${value.substring(6, 8)}일`
        : `${value.substring(0, 4)}-${value.substring(4, 6)}-${value.substring(6, 8)}`;
    } else if (value.length > 8) {
      text = value;
    } else {
      text = '-';
    }
    return text;
  }

  formatRpad(target, value, n) {
    return `${target}${Array(n - target.length + 1).join(value || '0')}`;
  }

  formatNumberToPhone(value) {
    return value.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
  }

  formatLpad(target, value, n) {
    if (this.isEmpty(target)) return '';
    target = target.toString();
    return `${Array(n - target.length + 1).join(value || '0')}${target}`;
  }

  secondsToTimes(value, format = [':', ':', '']) {
    value = parseInt(value);
    const hour = Math.floor(value / 3600);
    const minutes = Math.floor((value - hour * 3600) / 60);
    const seconds = value - hour * 3600 - minutes * 60;
    const covHour = this.formatLpad(hour, 0, '2');
    const covMinutes = this.formatLpad(minutes, 0, '2');
    const covSeconds = this.formatLpad(seconds, 0, '2');
    return `${covHour}${format[0]}${covMinutes}${format[1]}${covSeconds}${format[2]} `;
    // if (this.isEmpty(format)) return `${this.formatLpad(hour, 0, '2')}:${this.formatLpad(minutes, 0, '2')}:${this.formatLpad(seconds, 0, '2')}`
  }

  convertPyeong(value, flag = false) {
    if (this.isEmpty(value)) return 0;
    return flag ? value / 3.305785 : value * 3.305785;
  }

  fnConvertSssan(val) {
    return val === '1' ? '' : '산';
  }

  // 현재 url 공유
  intentShareUrl() {
    const currentUrl = location.href;
    this.nativeShareText(currentUrl);
  }
  focusOnInvalid() {
    const timeout = setTimeout(() => {
      const invalids = document.getElementsByClassName('is-invalid');
      const filtered = [...invalids].filter((element) => element.tagName.toLowerCase() === 'div');
      if (filtered && filtered.length > 0) {
        const target = filtered[0];
        target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      clearTimeout(timeout);
    });
  }

  isValid(v, el) {
    v.$touch();
    const isInvalid = v.$invalid;
    if (isInvalid) {
      // const options = {
      //   container: 'body',
      //   offset: -60,
      //   onDone: function (el) {
      //     // let msg = el.getAttribute('msg') || '필수 입력 항목 입니다.'
      //     // alert(msg)
      //     el = el.querySelector('input') || el;
      //     if (el) {
      //       setTimeout(() => {
      //         el.focus();
      //       }, 100);
      //     }
      //   }
      // };
      setTimeout(() => {
        el.querySelector('.is-invalid').scrollIntoView({ behavior: 'smooth' });
        // VueScrollTo.scrollTo(el.querySelector('.is-invalid'), 500, options);
      }, 100);
      return false;
    }
    return true;
  }

  // api.ipify.org을 통해 public ip를 가져옴
  getPublicIp() {
    // return fetch('https://api.ipify.org?format=json')
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://api.ipify.org?format=jsonp=', true);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          resolve(xhr.responseText);
        }
      };
      xhr.send(null);
    });
  }

  // toastAlert(Vue, msg, duration = 3000) {
  //   if (!this.isSafari) {
  //     alert(msg)
  //     return false
  //   }
  //   this.toastConfirm(Vue, msg, [{ text: '닫기', callBack: '' }], duration)
  // }

  toastAlert(Vue, msg, type = 'success') {
    Vue.$swal(msg);
  }

  toastConfirm(Vue, msg, args, duration = 8000) {
    if (!this.isSafari) {
      if (!confirm(msg)) {
        return false;
      }
      args.forEach((item) => {
        if (typeof item.callBack === 'function') return item.callBack('', { goAway: () => {} });
      });
      return false;
    }
    const actions = [];
    args.forEach((item) => {
      const map = {};
      map.text = item.text;
      map.onClick = (e, toastObject) =>
        typeof item.callBack !== 'function' ? toastObject.goAway(0) : item.callBack(e, toastObject);
      actions.push(map);
    });
    Vue.$toasted.clear();
    Vue.$toasted.show(msg, {
      action: actions,
      duration: duration
    });
  }

  maxLengthCheck(object) {
    if (object.value.length > object.maxLength) {
      object.value = object.value.slice(0, object.maxLength);
    }
  }

  /**
   * 디바이스 정보 native call
   * @param callBack(콜백 받을 functiuon name)
   * @return callBack(deviceTypeID, deviceID, registrationKey, isFirst)
   * @class Util
   */
  nativeGetRegistrationKey(callBack) {
    location.href = `native://action.${this.ConstCode.CODE_ENV_LIST.APP_SCHEMA}?cmd=getRegistrationKey&callback=${callBack}`;
  }

  /**
   * 기본 텍스트 공유
   * @param data(Intent 공유할 메세지 혹은 url)
   * @return ''
   * @class Util
   */
  nativeShareText(data) {
    location.href = `native://action.${
      this.ConstCode.CODE_ENV_LIST.APP_SCHEMA
    }?cmd=shareText&callback=CALLBACK&url=${encodeURIComponent(data)}`;
    return '';
  }

  /**
   * 기본 텍스트 공유
   * @param data(Intent 공유할 메세지 혹은 url)
   * @return ''
   * @class Util
   */
  nativeShareUrl(data) {
    data += '&rUrl=/main/map';
    location.href = `native://action.${
      this.ConstCode.CODE_ENV_LIST.APP_SCHEMA
    }?cmd=shareUrl&callback=CALLBACK&url=${encodeURIComponent(data)}`;
    return '';
  }

  /**
   * 카카오 공유
   * @param data(Intent 공유할 메세지 혹은 url)
   * @return ''
   * @class Util
   */
  nativeShareKaKao(data) {
    data += '&rUrl=/main/map';
    location.href = `native://action.${
      this.ConstCode.CODE_ENV_LIST.APP_SCHEMA
    }?cmd=shareKaKao&callback=CALLBACK&url=${encodeURIComponent(data)}`;
    return '';
  }

  /**
   * SHOW SMS
   * @param data(휴대폰번호)
   * @return ''
   * @class Util
   */
  nativeShowSms(data) {
    location.href = `native://action.${this.ConstCode.CODE_ENV_LIST.APP_SCHEMA}?cmd=showSms&callback=CALLBACK&data=${data}`;
  }

  /**
   * GET CURRENT LOCATE
   * @return ''
   * @class Util
   */
  nativeGetLocationWithLatLng(callBack) {
    location.href = `native://action.${this.ConstCode.CODE_ENV_LIST.APP_SCHEMA}?cmd=getLocationWithLatLng&callback=${callBack}`;
  }

  /**
   * 강제 인트로 HIDE
   * @return ''
   * @class Util
   */
  nativeHideIntro() {
    location.href = `native://action.${this.ConstCode.CODE_ENV_LIST.APP_SCHEMA}?cmd=hideIntro`;
  }

  /**
   * (shoppingValue) orderRequestNo로 주문시간 구하기
   * @param orderKey
   * @returns {string | *}
   */
  parseOrderKey(orderKey = '') {
    if (orderKey.length > 0) return orderKey.substr(2, 14);
    else return orderKey;
  }

  /**
   * Object -> queryString 변환
   * @param obj
   * @returns {string}
   */
  objectToQuerystring(obj) {
    return Object.keys(obj).reduce(function (str, key, i) {
      let delimiter, val;
      // eslint-disable-next-line prefer-const
      delimiter = i === 0 ? '?' : '&';
      key = encodeURIComponent(key);
      // eslint-disable-next-line prefer-const
      val = encodeURIComponent(obj[key]);
      return [str, delimiter, key, '=', val].join('');
    }, '');
  }

  convertTableData(tableColumns, tableData) {
    const list = [];
    tableColumns.forEach((column, index) => {
      const keyArr = column.prop ? column.prop.split('.') : [];
      const data = {};
      const fnFormatter = column.formatter ? column.formatter : '';
      tableData.forEach((item, itemIndex) => {
        let row = item;
        keyArr.forEach((key) => {
          row = row[key];
        });
        row = fnFormatter ? fnFormatter(item) : row;
        if (row || !this.isEmpty(row)) {
          data[`${column.label}`] = row;
          if (!list[itemIndex]) {
            list[itemIndex] = [];
          }
          if (!list[itemIndex][`${column.label}`]) {
            list[itemIndex][`${column.label}`] = {};
          }
          list[itemIndex][`${column.label}`] = row;
        }
      });
    });
    return list;
  }

  fnBusinessHour = () => {
    let newArr = [];
    for (let i = 0; i <= 23; i++) {
      newArr.push({
        label: i,
        value: i < 10 ? `0${i}` : `${i}`
      });
    }
    return newArr;
  };
  fnBusinessTime = () => {
    let newArr = [];
    for (let i = 0; i < 6; i++) {
      if (i > 0) {
        newArr.push({
          label: `${i * 10}`,
          value: `${i * 10}`
        });
      } else {
        newArr.push({
          label: `00`,
          value: `00`
        });
      }
    }
    return newArr;
  };
}
export default new Util();
